import { COMPANY_TYPE_CORPORATE, COMPANY_TYPE_DIVISION, COMPANY_TYPE_SUBSIDIARY } from '../../../../constants';

const { v1: uuidv1 } = require('uuid');
let data;
export const convertRowInfo = (rowInfo) => {
    let data = {};
    data.companyName = rowInfo.name;
    data['company-address1'] = rowInfo.address;
    data['company-address-city'] = rowInfo.city;
    data['company-address-state'] = rowInfo.state;
    data['zipCode'] = rowInfo.pinCode;
    data['GST-Number'] = rowInfo.gstNum;
    data['PAN-Number'] = rowInfo.panNum;
    data['TAN-Number'] = rowInfo.tanNum;
    data['purgeDuration'] = rowInfo.purgeDuration;
    data['corporate-category'] = rowInfo.corporateCategory;
    data['non-corporate-db-report-allowed'] = rowInfo.nonCorporateDBReportFlag.toString();
    data.id = rowInfo.id;
    data['corporate-type'] = rowInfo.type === COMPANY_TYPE_CORPORATE ? undefined : rowInfo.type === COMPANY_TYPE_DIVISION ? 'Division' : 'Subsidiary';
    return data;
}

export const convertApiData = (companyData) => {
        data = {
        name: companyData.companyName,
        address: companyData['company-address1'],
        city: companyData['company-address-city'],
        state: companyData['company-address-state'],
        pinCode: companyData['zipCode'],
        gstNum: companyData['GST-Number'],
        panNum: companyData['PAN-Number'],
        tanNum: companyData['TAN-Number'],
        nonCorporateDBReportFlag: companyData['non-corporate-db-report-allowed'] === 'true' ? true : false,
        children: [],
        userDetails: [],
        purgeDuration: companyData['purgeDuration'],
        corporateCategory:companyData['corporate-category'],
        type: companyData['corporate-type'] === undefined ? COMPANY_TYPE_CORPORATE : companyData['corporate-type'] === 'Subsidiary' ? COMPANY_TYPE_SUBSIDIARY : COMPANY_TYPE_DIVISION,
        //id: 'js_' + uuidv1(),
        expanded: true
    }
    return data;
}

export const generateNewCompanyData = () => {
    let data = {
        name: "",
        address: "",
        city: "",
        state: "",
        pinCode: "",
        gstNum: "",
        panNum: "",
        tanNum: "",
        children: [],
        userDetails: [],
        type: COMPANY_TYPE_CORPORATE,
        id: 'js_' + uuidv1(),
        expanded: true,
        corporateCategory:undefined,
        nonCorporateDBReportFlag: false
    }
    return data;
}

export const findNode = (newTreeData, data, nodeKeyInAction) => {
    for (let i = 0; i < newTreeData.length; i++) {
        if (newTreeData[i].id === nodeKeyInAction) {


            let children = Object.assign([], newTreeData[i].children);
            let userDetails = Object.assign([], newTreeData[i].userDetails);
            newTreeData[i] = data;
            newTreeData[i].children = children;
            newTreeData[i].userDetails = userDetails;
        }
        else {
            if (newTreeData[i].children.length > 0) {
                findNode(newTreeData[i].children, data, nodeKeyInAction);
            }
        }
    }
}

export const addNode = (newTreeData, nodeKeyInAction) => {
    var treeData = [];
    treeData.push(...newTreeData);
    while (treeData.length !== 0) {
        var test = treeData.pop();
        if (test.id === nodeKeyInAction) {
            let data = generateNewCompanyData();
            data.type = COMPANY_TYPE_SUBSIDIARY;

            test.children.push(data);
            return data;
        }
        else {
            if (test.children.length > 0) {

                treeData.push(...test.children);
            }
        }
    }
}

export const addUserInNode = (newTreeData, obj, userlist, nodeKeyInAction) => {
    for (let i = 0; i < newTreeData.length; i++) {
        if (newTreeData[i].id === nodeKeyInAction) {
            if (newTreeData[i].userDetails.find(x => x.id === obj.id) === undefined) {
                newTreeData[i].userDetails.push(obj);
                userlist.result = newTreeData[i].userDetails;
                userlist.initialUserDetailsValue = {};
            }
            else {
                newTreeData[i].userDetails[newTreeData[i].userDetails.indexOf(newTreeData[i].userDetails.find(x => x.id === obj.id))] = obj
                userlist.result = newTreeData[i].userDetails;
                userlist.initialUserDetailsValue = obj;
            }
        }
        else {
            if (newTreeData[i].children.length > 0) {
                addUserInNode(newTreeData[i].children, obj, userlist, nodeKeyInAction);
            }
        }
    }
}

export const deleteUserInNode = (newTreeData, id, data, nodeKeyInAction) => {
    for (let i = 0; i < newTreeData.length; i++) {
        if (newTreeData[i].id === nodeKeyInAction) {
            newTreeData[i].userDetails.splice(newTreeData[i].userDetails.indexOf(newTreeData[i].userDetails.find(x => x.id === id)), 1);
            data.userList = newTreeData[i].userDetails
        }
        else {
            if (newTreeData[i].children.length > 0) {
                deleteUserInNode(newTreeData[i].children, id, data, nodeKeyInAction);
            }
        }
    }
}

export const deleteCompanyDetailsInNode = (newTreeData, parentNode, nodeKeyInAction, deletedCompanyDetailsFlagObject) => {
    for (let i = 0; i < newTreeData.length; i++) {
        if (newTreeData[i].id === nodeKeyInAction) {
            if (newTreeData[i].name === "") {
                deletedCompanyDetailsFlagObject.addFlagInArray = false;
            }
            else {
                deletedCompanyDetailsFlagObject.addFlagInArray = true;
            }
            newTreeData.splice(i, 1);
            return parentNode;
            //data.userList = newTreeData[i].userDetails
        }
        else {
            if (newTreeData[i].children.length > 0) {
                return deleteCompanyDetailsInNode(newTreeData[i].children, newTreeData[i], nodeKeyInAction, deletedCompanyDetailsFlagObject);
            }
        }
    }
}

export const setWhiteLabelData = (data, companyData, treeData) => {
    let collection = []
    collection.push(treeData[0]);
    while (treeData.length) {
        let node = collection.shift();
        if (node.id === companyData.id) {

            node.logoBase64 = (data.corporateLogo) ? data.corporateLogo[0] : null
            node.colorHexCode = (data.corporateColor) ? data.corporateColor : null
            return treeData
        } else {
            collection.push(...node.children)
        }
    }
}